import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { MenuItem, Select } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Modal from '../Modals/Modal';
import Tabs from '../Tabs';
import Tab from '../Tab/Tab';
import Confirm from '../Modals/Body/Confirm';

function TabsLanguage({ children, initialValues, errors }) {
  const locale = useSelector((state) => state.locale);
  let addLang = locale.locales;

  const [delModal, setDelModal] = useState(false);
  const [del, setdel] = useState(null);

  const activeTabsParent = initialValues
    ? Object.keys(initialValues)
    : [locale.current];
  const [activeTabsLang, setActivetabsLang] = useState(activeTabsParent);

  if (!activeTabsLang || activeTabsLang.length < 1) {
    addLang = addLang.filter((item) => item !== locale.current);
  }
  activeTabsLang.forEach((i) => {
    addLang = addLang.filter((item) => item !== i);
  });
  const [langs, setLangs] = useState(addLang);

  const onSelectChange = (val) => {
    setLangs(langs.filter((item) => item !== val.target.value));
    setActivetabsLang([...activeTabsLang, val.target.value]);
  };

  const { t } = useTranslation();
  useEffect(() => {
    if (del || del === 0) {
      setDelModal(true);
    }
  }, [del, setdel]);
  const deleteLang = () => {
    const b = activeTabsLang.indexOf(del);
    if (b !== -1) {
      activeTabsLang.splice(b, 1);
      setActivetabsLang(activeTabsLang);
    }

    setLangs([...langs, del]);
  };

  return (
    <div style={{ marginTop: '20px ' }}>
      <Modal
        closeAction={() => {
          setDelModal(false);
          setdel(null);
        }}
        visible={delModal}
        transition={delModal}
        title={t('popup.deleteLang')}
      >
        <Confirm
          closeAction={() => {
            setDelModal(false);
            setdel(null);
          }}
          action={deleteLang}
        />
      </Modal>
      <div>
        <Select
          fullWidth
          onChange={onSelectChange}
          defaultValue=""
          value=""
          variant="outlined"
          MenuProps={{
            MenuListProps: {
              disablePadding: true,
            },
          }}
          disabled={!langs.length}
          displayEmpty
          renderValue={() => {
            if (langs.length) {
              return t('create.step2.choiseLang');
            }
            return t('create.step2.nonItemLang');
          }}
        >
          {langs.map((el, key) => (
            <MenuItem value={el} key={key} button>
              {t(`create.step2.element.${el}`)}
            </MenuItem>
          ))}
        </Select>
      </div>

      <div style={{ marginTop: '20px' }}>
        <Tabs
          defaultIndex={0}
          activeTabsLangLength={activeTabsLang.length}
          del={del}
        >
          {activeTabsLang &&
            activeTabsLang.map((lang) => (
              <Tab
                label={t(`create.step2.element.${lang}`)}
                extraActive={setdel}
                key={lang}
                errors={errors[lang]}
              >
                {children(lang)}
              </Tab>
            ))}
        </Tabs>
      </div>
    </div>
  );
}

TabsLanguage.propTypes = {
  children: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({}),
  errors: PropTypes.shape({}),
};
TabsLanguage.defaultProps = {
  errors: null,
  initialValues: null,
};
export default TabsLanguage;
